import { Component, OnDestroy, inject } from '@angular/core'
import { AuthStateService } from '@core/auth/auth-state.service'
import { User } from '@core/models'
import { AlertService } from '@core/services/alert.service'
import { TranslocoDirective, translate } from '@jsverse/transloco'
import { UserApiService } from '@main/user/services/user-api.service'
import { DialogRef } from '@ngneat/dialog'
import { NgpFileUpload } from 'ng-primitives/file-upload'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-change-profile-picture-dialog',
    standalone: true,
    imports: [NgpFileUpload, TranslocoDirective],
    templateUrl: './change-profile-picture-dialog.component.html',
    styleUrl: './change-profile-picture-dialog.component.scss',
})
export class ChangeProfilePictureDialogComponent implements OnDestroy {
    private userApiService = inject(UserApiService)
    private alertService = inject(AlertService)
    private auth = inject(AuthStateService)
    private profileSub!: Subscription
    private ref: DialogRef<any, string> = inject(DialogRef)
    private file: File | null = null

    imageSrc: string | ArrayBuffer | null = null

    onFilesSelected(files: FileList | null) {
        if (files) {
            this.file = files[0]
            if (this.file?.type.startsWith('image/')) {
                const reader = new FileReader()
                reader.onload = () => {
                    this.imageSrc = reader.result
                }
                reader.readAsDataURL(this.file)
            }
        }
    }

    save() {
        const userId = this.auth.getUserId()
        if (!this.file || !userId) return

        this.profileSub = this.userApiService
            .uploadProfilePicture(userId, this.file as File)
            .subscribe({
                next: (res) => {
                    this.alertService.success(translate('profile.pictureUpdated'))
                    this.auth.setUser({
                        ...this.auth.getUser(),
                        profilePicture: res.location,
                    } as User)
                    this.ref.close(res.location)
                },
                error: (error) => {
                    this.alertService.error(translate('profile.pictureUpdateError'))
                },
            })
    }

    close() {
        this.ref.close(this.auth.getUser()?.profilePicture)
    }

    ngOnDestroy(): void {
        if (this.profileSub) {
            this.profileSub.unsubscribe()
        }
    }
}
